/* RESPONSIBLE TEAM: team-frontend-tech */
import relativeTime from 'embercom/lib/relative-time';

let fullRelativeTime = function (dateString) {
  return relativeTime(dateString, 'en-full-relative-time');
};

export default fullRelativeTime;
